module.exports = __webpack_public_path__ + "img/en-plugin1.f8d0d4e4.png";